import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { GetRegionModal } from '../../../../../components/custom/modal/toast/GetRegionModal';
import { useAppSelector } from '../../../../../hooks/store/useStore';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessRegionPage = () => {
  const navigate = useNavigate();

  const [isGetRegionButtonClicked, setIsGetRegionButtonClicked] = useState<boolean>(false);

  const userRegionSelector = useAppSelector((state) => state.userRegion);

  return (
    <>
      <JoinProcessPageWrapper
        headerTitle={'회원님의 지역을 알려주세요'}
        description={'위치 정보 이용을 허용 해주세요.\n허용하지 않으면 서비스 이용이 불가능해요!'}
        canConfirm={userRegionSelector.userRegion !== undefined}
        confirmHandler={() => navigate('/join-process/job', { replace: true })}
      >
        <>
          <RegionSection>
            <RegionHeader>
              <RegionHeaderText>{'내 위치'}</RegionHeaderText>
            </RegionHeader>
            <RegionContent>
              <RegionInfoContainer>
                {userRegionSelector.userRegion === undefined ? (
                  <>
                    <Icon name="ExclamationMark" width={20} height={20} />
                    <RegionInfoText>{'아직 위치 정보가 없습니다.'}</RegionInfoText>
                  </>
                ) : (
                  <>
                    <IconWrapper>
                      <Icon name="RedCheck2" width={13} height={10} />
                    </IconWrapper>
                    <RegionInfoText>{userRegionSelector.userRegion}</RegionInfoText>
                  </>
                )}
              </RegionInfoContainer>
            </RegionContent>
          </RegionSection>

          <GetRegionButton onClick={() => setIsGetRegionButtonClicked(true)}>
            <Icon name="BlueMarker" width={20} height={20} />
            <GetRegionButtonText>{'내 위치 찾기'}</GetRegionButtonText>
          </GetRegionButton>
        </>
      </JoinProcessPageWrapper>

      {isGetRegionButtonClicked && <GetRegionModal onSettled={() => setIsGetRegionButtonClicked(false)} />}
    </>
  );
};

const RegionSection = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const RegionHeader = styled.div`
  width: 100%;
  height: 50px;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  padding: 16px 32px;

  border-bottom: 1px solid #e4e4ed;
`;

const RegionHeaderText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  text-align: center;

  /* Display/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
`;

const RegionContent = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 24px 32px;

  border-radius: var(--radius-none, 0px);
`;

const RegionInfoContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  padding: 16px;

  gap: 8px;

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey30, #d5d5e3);
  background: var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
`;

const RegionInfoText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const GetRegionButton = styled.button`
  width: 167px;
  max-height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const GetRegionButtonText = styled.span`
  color: var(--Light-Scheme-Color-primary-blue, #445eff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 5px 3px 5px 4px;
`;
